module.exports = __webpack_public_path__ + "static/favicon-d75ef9dc16debd8e343cd8af45f38147.png";